class CusstomFeaturedProductNew extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({"opacity":"1"});
      var countdesk = $(this).data('slide-count-desk');
      var countmob = $(this).data('slide-count-mob');
      var slidemarg = $(this).data('slide-margin');
      var slideloop = $(this).data('loop');
      var sectionId = this.getAttribute("data-sectionid")
      var swiper = new Swiper(".noat-card-container-"+this.getAttribute("data-sectionid"), {       
        loop: slideloop,  
        navigation: {
          prevEl: ".noat-button-prev-"+sectionId,
          nextEl:  ".noat-button-next-"+sectionId
        },
    mousewheel: {
              forceToAxis: true
            },
        breakpoints:{
          280: {
             slidesPerView: countmob,
              spaceBetween: 9,
    
          },
           480: {
             slidesPerView: countmob,
              spaceBetween: 17.5,
          },
          751:{
            slidesPerView: countmob,
              spaceBetween: 25.5
          },
          990: {
             slidesPerView: countdesk ,
             spaceBetween: slidemarg
    
          }
        }
      });

      $(document).ready(function(){
        $('.noat-card .featured-product-button-text').mouseenter(function(){
          $(this).find(".noat-card-text-under-line").addClass("animate-under-line");
          $(this).find(".button-text-under-line").addClass("animate-under-line");
        });
        
        $('.noat-card').mouseleave(function(){
          $(this).find(".noat-card-text-under-line").removeClass("animate-under-line");
          $(this).find(".button-text-under-line").removeClass("animate-under-line");
       });

       $('.noat-card-click').unbind().click(function(){
         if ($(this).find('.overlay-content-main').hasClass("show-overlay-content")) {
            $('.overlay-content-main').removeClass('show-overlay-content');
            $(this).find('.overlay-content-main').removeClass('show-overlay-content');
          }else{
            $('.overlay-content-main').removeClass('show-overlay-content');
            $(this).find('.overlay-content-main').addClass('show-overlay-content');
          }
       });
      });
    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-featured-product-new", CusstomFeaturedProductNew);


class CustomContentwithFaqs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
          } else {
            $(".noat-accordion-inner-box").find(".faq-answers").removeClass("show");
            $(".noat-accordion-inner-box").find(".faq-answers").slideUp(350);
            $(".noat-accordion-inner-box").removeClass("active");

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-content-with-faqs", CustomContentwithFaqs);



class Accordionclickbundle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
          } else {
            $(".noat-accordion-inner-box").find(".faq-answers").removeClass("show");
            $(".noat-accordion-inner-box").find(".faq-answers").slideUp(350);
            $(".noat-accordion-inner-box").removeClass("active");

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("accordion-click-bundle", Accordionclickbundle);


function updateDisplayWidth() {
  // Get the viewport width
  const viewportWidth = window.innerWidth;

  // Get the document width
  const documentWidth = document.documentElement.clientWidth;

  // Check if scrollbar is visible
  const scrollbarVisible = viewportWidth > documentWidth;

  // Calculate display width excluding scrollbar if visible
  const displayWidth = scrollbarVisible ? documentWidth : viewportWidth;

  // Update CSS custom property
  document.documentElement.style.setProperty('--display-width', `${displayWidth}px`);
}

// Call the function initially and on resize
updateDisplayWidth();
window.addEventListener('resize', updateDisplayWidth);
